var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-table',{ref:"LTable",attrs:{"module-name":_vm.MODULE_NAME,"table-columns":_vm.tableColumns,"table-title":"Recommended scientific topics"},scopedSlots:_vm._u([{key:"cell(region)",fn:function(ref){
var data = ref.data;
return [_vm._v(" "+_vm._s(_vm.$langName(data.value))+" ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }